<template>
  <div>
    <v-container class="toolbar__container">
      <v-row>
        <v-col cols="12" sm="6" md="2">
          <v-menu
            ref="menuInicio"
            v-model="menuInicio"
            transition="scale-transition"
            offset-y
            min-width="auto"
            :close-on-content-click="false"
            :return-value.sync="dtInicio"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="fmtDataHora(dtInicio)"
                :label="$t('statusDispositivos.filters.startDate')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-bind="attrs"
                v-on="on"
                @click:clear="dtInicio = null"
              />
            </template>
            <v-date-picker v-model="dtInicio" no-title scrollable :locale="$i18n.locale">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menuInicio = false">{{ $t('button.cancel') }}</v-btn>
              <v-btn text color="primary" @click="$refs.menuInicio.save(dtInicio)">{{ $t('button.validate') }}</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-menu
            ref="menuFim"
            v-model="menuFim"
            transition="scale-transition"
            offset-y
            min-width="auto"
            :close-on-content-click="false"
            :return-value.sync="dtFim"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="fmtDataHora(dtFim)"
                :label="$t('statusDispositivos.filters.endDate')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-bind="attrs"
                v-on="on"
                @click:clear="dtFim = null"
              />
            </template>
            <v-date-picker v-model="dtFim" no-title scrollable :locale="$i18n.locale">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menuFim = false">{{ $t('button.cancel') }}</v-btn>
              <v-btn text color="primary" @click="$refs.menuFim.save(dtFim)">{{ $t('button.validate') }}</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete
            v-model="idEquipamento"
            :items="equipamentos"
            :item-text="rotuloEquipamento"
            item-value="id_equipamento"
            clearable
            :label="$t('statusDispositivos.filters.equipment')"
            :placeholder="$t('statusDispositivos.messages.allEquipments')"
            persistent-placeholder
          />
        </v-col>
        <v-col cols="6" sm="4" md="2">
          <v-select v-model="suite" :items="suites" clearable :label="$t('statusDispositivos.filters.suite')" />
        </v-col>
        <v-col cols="6" sm="4" md="1">
          <v-select v-model="origem" :items="origens" clearable :label="$t('statusDispositivos.filters.origin')" />
        </v-col>
        <v-col cols="6" sm="4" md="1">
          <v-select v-model="modo" :items="modos" clearable :label="$t('statusDispositivos.filters.mode')" />
        </v-col>
        <v-col cols="6" sm="4" md="2">
          <v-select v-model="status" :items="statuses" clearable :label="$t('statusDispositivos.filters.runStatus')" />
        </v-col>
        <v-col cols="6" sm="12" md="1" class="d-flex align-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on" :loading="loading" @click="popula">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('statusDispositivos.actions.search') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <merus-data-table
      :key="tableKey"
      cod-tabela="EQUIPAMENTOS__VALIDADORES_ATUALIZACOES"
      :headers="headers"
      :items="itens"
      :loading="loading"
      item-key="id_atualizacao"
      :show-expand="true"
      :single-expand="true"
      @update:headers="headers = $event"
    >
      <template v-slot:toolbar>
        <CadastroToolbar
          :title="$t('statusDispositivos.modules.updatesReport')"
          :token="token"
          :items="itens"
          csv-title="dispositivos_atualizacoes"
          :csv-headers="headers"
          :pdf-title="$t('statusDispositivos.modules.updatesReport')"
          :pdf-headers="headers"
          pdf-filename="dispositivos_atualizacoes"
          hide-search
        />
      </template>

      <template v-slot:item.status_extenso="{ item }">
        <v-chip small dark :color="corStatus(item.status)">{{ item.status_extenso }}</v-chip>
      </template>

      <template v-slot:item.total_erro="{ item }">
        <span :class="item.total_erro > 0 ? 'red--text' : ''">{{ item.total_erro }}</span>
      </template>

      <template v-slot:item.actions="{ item, isExpanded, expand }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon small color="primary" v-on="on" @click="alternarExpandir(item, isExpanded, expand)">
              <v-icon small>{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('statusDispositivos.actions.viewItems') }}</span>
        </v-tooltip>
      </template>

      <template v-slot:expanded-item="{ item }">
        <div style="width: 100%; padding: 8px">
          <merus-data-table
            :headers="headersItens"
            :items="itensDe(item.id_atualizacao).lista"
            :loading="itensDe(item.id_atualizacao).loading"
            item-key="id_item"
            flat
          >
            <template v-slot:item.sucesso_extenso="{ item: linha }">
              <span :class="linha.sucesso == 1 ? 'green--text' : 'red--text'">{{ linha.sucesso_extenso }}</span>
            </template>
          </merus-data-table>
        </div>
      </template>
    </merus-data-table>
  </div>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import MerusDataTable from '../../Tables/MerusDataTable.vue';
import CadastroToolbar from '../../Toolbars/CadastroToolbar.vue';
import dispositivosFormatters from './dispositivosFormatters';
import recorteEquipamentos from './recorteEquipamentos';

const ORIGENS = ['rotina', 'manual'];
const MODOS = ['inventory', 'apply', 'reapply'];
const STATUSES = ['running', 'ok', 'erro'];

export default {
  name: 'RelatorioAtualizacoes',
  components: { MerusDataTable, CadastroToolbar },
  mixins: [dispositivosFormatters, recorteEquipamentos],
  props: {
    equipamentos: { type: Array, default: () => [] },
    token: { type: String, default: null },
  },
  data: () => ({
    menuInicio: false,
    menuFim: false,
    dtInicio: null,
    dtFim: null,
    idEquipamento: null,
    suite: null,
    origem: null,
    modo: null,
    status: null,
    loading: false,
    itens: [],
    headers: [],
    headersItens: [],
    detalhes: {},
  }),
  computed: {
    tableKey() {
      return `dispositivos-atualizacoes-${this.$i18n.locale}`;
    },
    // Opções de suite saem da própria frota: sem chamada extra e sem oferecer suite que
    // nenhum equipamento usa.
    suites() {
      const vistas = new Map();
      (this.equipamentos || []).forEach((e) => {
        if (e.suite_efetiva && !vistas.has(e.suite_efetiva)) {
          vistas.set(e.suite_efetiva, { value: e.suite_efetiva, text: e.nome_suite || e.suite_efetiva });
        }
      });
      return Array.from(vistas.values());
    },
    origens() {
      return ORIGENS.map((v) => ({ value: v, text: this.$t(`statusDispositivos.origin.${v}`) }));
    },
    modos() {
      return MODOS.map((v) => ({ value: v, text: this.$t(`statusDispositivos.mode.${v}`) }));
    },
    statuses() {
      return STATUSES.map((v) => ({ value: v, text: this.$t(`statusDispositivos.runStatus.${v}`) }));
    },
  },
  watch: {
    '$i18n.locale'() {
      this.initializeHeaders();
      this.itens = this.itens.map((i) => this.decora(i));
      this.detalhes = {};
    },
  },
  created() {
    this.initializeHeaders();
    this.popula();
  },
  methods: {
    rotuloEquipamento(item) {
      return item.cod_veiculo ? `${item.nome_equipamento} (${item.cod_veiculo})` : item.nome_equipamento;
    },
    initializeHeaders() {
      const h = this.$t.bind(this);
      this.headers = [
        { text: h('statusDispositivos.headers.runId'), value: 'id_atualizacao', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.startedAt'), value: 'dt_inicio_extenso', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.finishedAt'), value: 'dt_fim_extenso', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.suite'), value: 'suite_extenso', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.origin'), value: 'origem_extenso', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.mode'), value: 'modo_extenso', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.equipment'), value: 'nome_equipamento', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.totalOk'), value: 'total_ok', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.totalError'), value: 'total_erro', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.runStatus'), value: 'status_extenso', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.triggeredBy'), value: 'nome_usuario', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.reason'), value: 'motivo', sortable: true, filtrable: true },
      ];
      this.headersItens = [
        { text: h('statusDispositivos.headers.eventAt'), value: 'dt_evento_extenso', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.equipment'), value: 'nome_equipamento', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.personName'), value: 'nome_completo', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.cardNo'), value: 'card_no', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.operation'), value: 'operacao_extenso', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.success'), value: 'sucesso_extenso', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.message'), value: 'mensagem', sortable: true, filtrable: true },
        { text: h('statusDispositivos.headers.exception'), value: 'excecao_extenso', sortable: true, filtrable: true },
      ];
    },
    corStatus(status) {
      if (status === 'ok') return 'green';
      if (status === 'erro') return 'red';
      return 'blue-grey';
    },
    decora(linha) {
      return {
        ...linha,
        suite_extenso: linha.nome_suite || linha.suite || '',
        dt_inicio_extenso: this.fmtDataHora(linha.dt_inicio),
        dt_fim_extenso: this.fmtDataHora(linha.dt_fim),
        origem_extenso: this.traduzDominio('origin', linha.origem),
        modo_extenso: this.traduzDominio('mode', linha.modo),
        status_extenso: this.traduzDominio('runStatus', linha.status),
      };
    },
    itensDe(idAtualizacao) {
      return this.detalhes[idAtualizacao] || { lista: [], loading: false };
    },
    alternarExpandir(item, isExpanded, expand) {
      expand(!isExpanded);
      if (!isExpanded) this.carregaItens(item.id_atualizacao);
    },
    carregaItens(idAtualizacao) {
      if (this.detalhes[idAtualizacao]) return;
      this.$set(this.detalhes, idAtualizacao, { lista: [], loading: true });
      apiController.request(apiController.endpoints.isapiGetIsapiatualizacaoitens, {
        data: { id_atualizacao: idAtualizacao },
        silent: true,
        onSuccess: (response) => {
          this.$set(this.detalhes, idAtualizacao, {
            lista: (response.data || []).map((linha) => ({
              ...linha,
              dt_evento_extenso: this.fmtDataHora(linha.dt_evento),
              operacao_extenso: this.traduzDominio('operation', linha.operacao),
              sucesso_extenso: this.fmtSimNao(linha.sucesso),
              // Operação causada por exceção manual: número, tipo e motivo, para a auditoria.
              excecao_extenso: linha.id_excecao
                ? `#${linha.id_excecao} ${this.traduzDominio('access.type', linha.tipo_excecao)}: ${linha.motivo_excecao || ''}`
                : '',
            })),
            loading: false,
          });
        },
        onError: (error) => {
          this.$delete(this.detalhes, idAtualizacao);
          EventBus.$emit('show-error', { error });
        },
      }).catch(() => {});
    },
    popula() {
      this.loading = true;
      this.detalhes = {};
      const filtros = {};
      if (this.dtInicio) filtros.dt_inicio = `${this.dtInicio} 00:00:00`;
      // A API compara dt_fim contra o início da execução; sem a hora, o próprio dia filtrado ficaria de fora.
      if (this.dtFim) filtros.dt_fim = `${this.dtFim} 23:59:59`;
      if (this.idEquipamento != null) filtros.id_equipamento = this.idEquipamento;
      if (this.suite) filtros.suite = this.suite;
      if (this.origem) filtros.origem = this.origem;
      if (this.modo) filtros.modo = this.modo;
      if (this.status) filtros.status = this.status;

      apiController.request(apiController.endpoints.isapiGetIsapiatualizacoes, {
        data: filtros,
        onSuccess: (response) => {
          // No recorte por veículo a execução de frota (sem equipamento) também passou por ele.
          const linhas = response.data || [];
          this.itens = (this.apenasDaLista ? linhas.filter((l) => l.id_equipamento == null || this.idsDaLista.has(l.id_equipamento)) : linhas)
            .map((linha) => this.decora(linha));
        },
        onError: () => {
          this.itens = [];
        },
      })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
